import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./servicos.component.html')
})
export class ServicosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/servicos.component.ts
 **/